<template>
    <div class="survey-mission">
        <CampaignList
            :lbl="lbl"
            :isLoading='isLoading'
            :initListConfig="listConfig"
            :initFilterConfig="filterConfig"
            :busEvent="busCampaign"
            :type="item_type"
            @toggleLoading="toggleLoading($event)" />
    </div>
</template>
<script>
import Vue from "vue";
import ConfigManager from "@/config/ConfigManager.js";
//component
import CampaignList from "@/module/List/component/CampaignList.vue";
//core
import {
  CampaignListConfigBuilder,
  CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";

export default {
    name: 'SurveyList',
    components: {
        CampaignList,
    },
    props:{
        lbl: Object,
        mission: Object,
        modalController: Object,
        surveyDraw: Boolean,
        type: String,
    },
    data: function(){
        return {
            isLoading: false,
            listConfig: {},
            filterConfig: {},
            busCampaign: new Vue(),
            item_type: "survey",
        }
    },
    created: function(){
        this.initialConfig();
    },
    methods: {
        //initial
        initialConfig: function() {
            var configStr = ConfigManager.getCampaignConfig();
            var configName = this.surveyDraw ? configStr.campaignSurveyDrawListConfig :configStr.campaignSurveyListConfig;
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(configName)
                
            this.listConfig = listConfig.create();

            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
            this.item_type = this.type; 
        },
        //utilities
        showLoading: function() {
            setTimeout(() => {
                this.modalController.loadingModal.show();
            },0)
        },
        hideLoading: function() {
            setTimeout(() => {
                this.modalController.loadingModal.hide();
            },300)
        },
        toggleLoading: function (isLoading) {
            this.isLoading = isLoading;
            if(this.isLoading){
                this.showLoading();
            }else{
                this.hideLoading();
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.survey-mission{
    padding: {
        top: $topbar-height + 20px;
        bottom: 30px;
    }
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/base/baseImage.scss";
@import "@/style/base/baseText.scss";
@import "../style/SurveyList.scss";
</style>